<!-- BatchDeleteActivityGeneralForm.vue -->
<!-- Modal de confirmação de exclusão em lote de atividades gerais.          -->
<!-- Baseado em BatchDeleteActivityForm.vue; usa useActivityGeneralStore.    -->
<!-- Diferença: recebe `activityIds` como prop (IDs já filtrados pelo form)  -->
<!-- em vez de ler diretamente store.selectedActivityIds, evitando que o     -->
<!-- modal apague IDs sem permissão que o pai já excluiu da seleção.         -->
<script setup>
import { computed, ref } from "vue";
import { useActivityGeneralStore } from "@/stores/useActivityGeneralStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  // ✅ lista de IDs já filtrada pelo ActivityGeneralForm (eligible)
  activityIds: { type: Array, required: true },
});

const emit  = defineEmits(["close", "refresh", "notify"]);
const store = useActivityGeneralStore();

// ── contagem congelada ao abrir (não muda quando a store limpa a seleção) ────
const frozenCount = ref(props.activityIds.length || 1);

const messageTitle = computed(() => {
  if (frozenCount.value === 1)
    return "Tem certeza que deseja apagar a atividade selecionada?";
  return `Tem certeza que deseja apagar as ${frozenCount.value} atividades selecionadas?`;
});

// ── handler de confirmação ───────────────────────────────────────────────────
async function onConfirmBatchDelete() {
  try {
    // ✅ usa os IDs passados como prop (elegíveis), não os da store inteira
    await store.deleteActivitiesByIds(props.activityIds);

    const msg =
      frozenCount.value === 1
        ? "Atividade apagada com sucesso."
        : "Atividades apagadas com sucesso.";

    emit("notify", { type: "success", message: msg });
    emit("refresh");
    emit("close");
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Ocorreu um erro ao excluir as atividades.";

    emit("notify", { type: "error", message: msg });
    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Atividades em Lote"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-las serão excluídas também todas as Notas vinculadas a elas. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmBatchDelete"
    @close="emit('close')"
  />
</template>